import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";

const MultiSelectWithCreate = ({ initialSelectedSizes, onChange }) => {
  // Define gearbox sizes as an array of strings
  const gearboxSizes = [
  ];

  // Convert array of strings to dropdown format { value, label }
  const initialOptions = gearboxSizes.map((size) => ({
    value: size,
    label: size,
  }));

  // Convert initialSelectedSizes (Array of strings) to {value, label} format
  const convertToDropdownFormat = (sizes) =>
    sizes?.map((size) => ({ value: size, label: size })) || [];

  // State for selected values and dropdown options
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState(initialOptions);

  // Set initial selected options when editing
  useEffect(() => {
    if (initialSelectedSizes) {
      setSelectedOptions(convertToDropdownFormat(initialSelectedSizes));
    }
  }, [initialSelectedSizes]);

  // Handle selection change
  const handleChange = (newValue) => {
    setSelectedOptions(newValue);
    // Pass array of strings back to parent
    onChange(newValue ? newValue.map(option => option.value) : []);
  };

  // Handle creation of new options
  const handleCreate = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setOptions((prevOptions) => [...prevOptions, newOption]); // Add new value
    setSelectedOptions((prevSelected) => {
      const newSelected = [...prevSelected, newOption];
      // Pass array of strings back to parent
      onChange([...newSelected.map(option => option.value)]);
      return newSelected;
    });
  };

  return (
    <div>
      <CreatableSelect
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        onCreateOption={handleCreate}
        placeholder="Select or type to add..."
      />
    </div>
  );
};

export default MultiSelectWithCreate;